import script from "./leftMenuNav.vue?vue&type=script&setup=true&lang=js"
export * from "./leftMenuNav.vue?vue&type=script&setup=true&lang=js"

import "./leftMenuNav.vue?vue&type=style&index=0&id=506231b0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-506231b0"]])

export default __exports__